import React from 'react';

import {useTranslation} from 'react-i18next';

import {Title} from 'components/ui-kit/Title';

import {Container, CustomLink} from './styled';

export function NotFound() {
    const {t} = useTranslation();
    return (
        <Container>
            <Title size={2}>{t('components.notFound.title')}</Title>
            <CustomLink to="/">{t('components.notFound.toMain')}</CustomLink>
        </Container>
    );
}
